import { create } from 'zustand';

import { api } from './api.js';

/**
 * Tiny session store. The backend session is the source of truth — we just
 * cache the user object client-side after login / `/auth/me`.
 */
export const useSessionStore = create((set) => ({
  user: null,
  loading: true,

  setUser(user) {
    set({ user, loading: false });
  },

  async hydrate() {
    set({ loading: true });
    try {
      const { data } = await api.get('/auth/me');
      set({ user: data, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },

  async login({ email, password, consent }) {
    const { data } = await api.post('/auth/login', { email, password, consent });
    set({ user: data.requiresTwoFactor ? null : data, loading: false });
    return data; // may include requiresTwoFactor
  },

  async verifyTwoFactor(token) {
    const { data } = await api.post('/auth/2fa', { token });
    set({ user: data, loading: false });
    return data;
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } finally {
      set({ user: null });
    }
  },
}));
